// frontend/src/components/games/memory/DifficultySelector.tsx

import { MEMORY_DIFFICULTIES, MemoryDifficulty } from '../../../hooks/games/useMemoryGame';

interface DifficultySelectorProps {
  current: MemoryDifficulty;
  onSelect: (difficulty: MemoryDifficulty) => void;
}

const ORDER: MemoryDifficulty[] = ['easy', 'medium', 'hard'];

export function DifficultySelector({ current, onSelect }: DifficultySelectorProps) {
  return (
    <div className="memory-difficulty-selector">
      {ORDER.map((key) => {
        const config = MEMORY_DIFFICULTIES[key];
        return (
          <button
            key={key}
            type="button"
            className={`memory-difficulty-btn ${current === key ? 'active' : ''}`}
            onClick={() => onSelect(key)}
          >
            {config.label} <span>({config.gridSize}x{config.gridSize})</span>
          </button>
        );
      })}
    </div>
  );
}
